module.exports = __webpack_public_path__ + "img/target.b507c79f.png";